import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { firestoreConnect } from "react-redux-firebase"
import NotificationAlert from "react-notification-alert"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { CustomPagination } from "components/Common"
import Config from "config"

import {
  Card,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  Table,
  Container,
  Row,
} from "reactstrap"

class Users extends React.Component {
  state = {
    challenges: [],
    category: [],
    toggleUser: {
      uid: null,
      disabled: false,
    },
    start: 0,
    end: 0,
  }

  _handlePaginationClick(start, end) {
    if (start >= 0 && end >= 0) {
      this.setState({
        start,
        end,
      })
    }
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  makeUserAdmin = async (email) => {
    try {
      const fetchOptions = {
        method: "POST",
        body: JSON.stringify({
          email,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
      const res = await fetch(
        Config.FirebaseFunctionUrl + "/app/addAdminRole",
        fetchOptions
      )
      const jsonRes = await res.json()
      this.notify(
        "success",
        jsonRes?.message || "user made admin succesfully",
        "Success"
      )
    } catch (error) {
      this.notify(
        "error",
        error?.message || "error while making user admin",
        "Error"
      )
    }
  }

  render() {
    const { users } = this.props
    const { start, end } = this.state
    return (
      <>
        <SimpleHeader name="All Users" parentName="Users" />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader className="border-0">
                  <h3 className="mb-0">Users</h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light text-center">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        Name
                      </th>
                      <th className="sort" data-sort="budget" scope="col">
                        Email
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Time
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="list text-center">
                    {users &&
                      users.length > 0 &&
                      users.slice(start, end).map((user) => {
                        return (
                          <tr key={user.id}>
                            <th scope="row">
                              <Media className="align-items-center">
                                <a
                                  className="avatar rounded-circle mr-3"
                                  href="#fa"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    src={
                                      user.photoURL
                                        ? user.photoURL
                                        : require("assets/img/theme/blank-profile.png")
                                    }
                                  />
                                </a>
                                <Media>
                                  <span className="name mb-0 text-sm">
                                    {user.name}
                                  </span>
                                </Media>
                              </Media>
                            </th>
                            <td className="budget">{user.email}</td>
                            <td>
                              {user.time
                                ? user.time.toDate().toDateString()
                                : null}
                            </td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    href="#fa"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    Edit
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      this.props.toggleUserStatus({
                                        uid: user.id,
                                        disabled:
                                          user.status === "disabled"
                                            ? "enabled"
                                            : "disabled",
                                      })
                                    }
                                  >
                                    {user.status === "disabled"
                                      ? "Enable User"
                                      : "Disable User"}
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      this.makeUserAdmin(user?.email)
                                    }
                                  >
                                    Make Admin
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
                <CustomPagination
                  pageSize={5}
                  dataLen={this.props.users ? this.props.users.length : 0}
                  stateCallback={this._handlePaginationClick.bind(this)}
                />
              </Card>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    oid: state.firebase.auth.uid,
    users: state.firestore.ordered.users,
  }
}

const mapDispatchToProps = (dispatch) => {
  // return {
  //   toggleUserStatus: (data) => dispatch(toggleUserStatus(data))
  // }
  return {}
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "customers",
      storeAs: "users",
    },
  ])
)(Users)
